export enum DOWNLOAD_TYPE {
  PDF = 'PDF',
  XLSX = 'XLSX',
  CSV = 'CSV',
  XLS = 'XLS',
}

export enum DATA_TYPE {
  STATE_OF_REPORTS = 'STATE_OF_REPORTS',
  INTAKE_PER_CATEGORY = 'INTAKE_PER_CATEGORY',
  REPORT_STATUS_CATEGORY = 'REPORT_STATUS_CATEGORY',
  DEPARTMENTS_ACROSS_LOCATIONS = 'DEPARTMENTS_ACROSS_LOCATIONS',
  CATEGORIES_PER_DEPARTMENT = 'CATEGORIES_PER_DEPARTMENT',
}
